import { makeStyles } from "@material-ui/core";

const styles = makeStyles(({ spacing, palette }) => ({
  noResultImg: {
    width: 204,
    height: 124,
  },
  noResultBlock: {
    padding: spacing(4, 5),
    backgroundColor: palette.otherElementsBackground.main,
    borderRadius: spacing(1.5),
  },
  shiftedBlock: {
    marginTop: spacing(3),
  },
  noResultMessage: {
    fontSize: "18px",
    lineHeight: 1.5,
    color: palette.contrastText.main,
    fontWeight: 600,
    maxWidth: "100%",
    wordBreak: "break-word",
  },
}));

export default styles;
